import { css } from 'lit';

/**
 * Shared reset + typography injected into every component's shadow root via SsoElement.
 * Token-driven so a theme change re-skins everything.
 */
export const base = css`
  :host {
    box-sizing: border-box;
    color: var(--sso-color-fg);
    font: var(--sso-font-body);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a {
    color: var(--sso-color-brand);
    text-decoration: underline;
    text-underline-offset: 0.15em;
  }

  a:focus-visible,
  :host(:focus-visible) {
    outline: none;
    box-shadow: var(--sso-focus-ring);
    border-radius: 4px;
  }

  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0 0 var(--sso-space) 0;
  }

  h1 {
    font: var(--sso-font-h1);
    color: var(--sso-color-brand);
  }

  h2,
  h3,
  h4 {
    font-family: var(--sso-font-heading-family);
    color: var(--sso-color-soft-blue);
    line-height: 1.3;
  }

  p {
    color: var(--sso-color-muted);
  }

  /* Respect users who prefer reduced motion (a11y). */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.001ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.001ms !important;
    }
  }

  /* Visually hidden but available to screen readers. */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
